import React from "react";
import { Button } from "../../tremor/Button";
import { Text } from "../../tremor/Text";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../tremor/Select";
export const PaginationComponent = ({ pagination, stats, setPagination, padding }) => {
    const { currentPage, pageSize } = pagination;
    const { totalPages } = stats;
    const handlePageSizeChange = (val) => {
        const newPageSize = parseInt(val) || 10;
        setPagination((prev) => (Object.assign(Object.assign({}, prev), { pageSize: newPageSize })));
    };
    const handlePageChange = (val) => {
        const newPage = parseInt(val) || 1;
        if (newPage >= 1 && newPage <= totalPages) {
            setPagination((prev) => (Object.assign(Object.assign({}, prev), { currentPage: newPage })));
        }
    };
    const handlePreviousPage = () => {
        setPagination((prev) => prev.currentPage > 1
            ? Object.assign(Object.assign({}, prev), { currentPage: prev.currentPage - 1 }) : prev);
    };
    const handleNextPage = () => {
        setPagination((prev) => prev.currentPage < totalPages
            ? Object.assign(Object.assign({}, prev), { currentPage: prev.currentPage + 1 }) : prev);
    };
    return (React.createElement(Text, { style: { padding: `0px ${(padding)}px` }, className: "onvo-flex onvo-flex-row onvo-text-sm onvo-items-center onvo-gap-2 onvo-w-full onvo-mt-0 onvo-px-2" },
        "Display",
        " ",
        React.createElement(Select, { value: pageSize + "", onValueChange: (val) => handlePageSizeChange(val) },
            React.createElement(SelectTrigger, { className: "onvo-w-20 onvo-max-w-20 !onvo-py-1" },
                React.createElement(SelectValue, { placeholder: "10" })),
            React.createElement(SelectContent, null, [100, 500, 1000].map((option) => (React.createElement(SelectItem, { key: option + "", value: option + "" }, option + ""))))),
        "Page",
        " ",
        React.createElement(Select, { value: currentPage + "", onValueChange: (val) => handlePageChange(val) },
            React.createElement(SelectTrigger, { className: "onvo-w-20 onvo-max-w-20 !onvo-py-1" },
                React.createElement(SelectValue, { placeholder: "1" })),
            React.createElement(SelectContent, null, new Array(totalPages).fill(0).map((_, i) => (React.createElement(SelectItem, { key: i + "", value: (i + 1) + "" }, i + 1))))),
        "of ",
        totalPages,
        React.createElement("div", { className: "onvo-flex-grow" }),
        React.createElement(Button, { variant: "secondary", className: "!onvo-py-1", onClick: handlePreviousPage, disabled: currentPage <= 1 }, "Previous"),
        React.createElement(Button, { variant: "secondary", className: "!onvo-py-1", onClick: handleNextPage, disabled: currentPage >= totalPages }, "Next")));
};
//# sourceMappingURL=PaginationComponent.js.map